import { useCallback, useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";

//Servics
import { SosAlertService } from "../../services/SosAlertService";

//Components
import SosAlertList from "./SosAlertList";

//Common Components
import TransactionButton from "../Common/TransactionButton";

//Enum
import { CkSosTicketStatusEnum } from "../../enums/CkSosTicketStatusEnum";

//Svg
import { FilterIcon } from "../Svg";

//Styles
import { FilterContainer, FIlterHeader, FilterInput, FilterSection, FilterTextField, FilterWrapper, SectionHeader, SectionTitle, WorkspaceContainer, WorkSpaceTitleRow } from "../../styles/commonStyles";
import moment from "moment";
import { MenuItem } from "@mui/material";

//Constants
const sosAlertServices = new SosAlertService();

const SosAlerts = () => {

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false)
  const [sosIdInput, setSosIdInput] = useState<string>("");
  const [referenceIdInput, setReferenceIdInput] = useState<string>("")
  const [debouncedSosId, setDebouncedSosId] = useState<string>("");
  const [debouncedReferenceId, setDebouncedReferenceId] =
    useState<string>("");
  const [date, setDate] = useState<Date | null>(null);
  const [debouncedDate, setDebouncedDate] = useState<Date | null>(null);  
  const [status, setStatus] = useState<CkSosTicketStatusEnum | "">("");
  const [debouncedStatus, setDebouncedStatus] =
    useState<CkSosTicketStatusEnum | "">("");    

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);



   useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSosId(sosIdInput);
      setDebouncedReferenceId(referenceIdInput);
      setDebouncedDate(date);
      setDebouncedStatus(status);
    }, 600);

    return () => clearTimeout(timer);
  }, [sosIdInput, referenceIdInput, date, status]);


const loadData = useCallback(async () => {
  setLoading(true);

  try {
    const filters: any = {
      ...(debouncedSosId && { id: Number(debouncedSosId) }),
      ...(debouncedReferenceId && {
        referenceId: Number(debouncedReferenceId),
      }),
      ...(debouncedDate && {
        startDate: moment(debouncedDate).startOf("day").toISOString(),
        endDate: moment(debouncedDate).endOf("day").toISOString(),
      }),
      ...(debouncedStatus && { status: debouncedStatus }),
    };

    const response = await sosAlertServices.getAllSosAlerts(
      rowsPerPage,
      page * rowsPerPage,
      filters,
      { field: "id", order: "DESC" }
    );

    setData(response.data);
    setTotal(response.total);
  } catch (error) {
    setData([]);
    setTotal(0);
  } finally {
    setLoading(false);
  }
}, [page, rowsPerPage, debouncedSosId, debouncedReferenceId, debouncedDate, debouncedStatus]);


  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSosId, debouncedReferenceId]);

    return(
      <WorkspaceContainer>
        <FilterWrapper>
          <FIlterHeader>
            <FilterSection style={{ marginBottom: "0" }}>
              <SectionHeader>
                <WorkSpaceTitleRow>
                  <FilterIcon color="#1976d2" height={20} width={20} />
                  <SectionTitle>Filters</SectionTitle>
                </WorkSpaceTitleRow>
              </SectionHeader>

              <TransactionButton
                name={"Clear Filter"}
                onClickHandler={() => {
                  setSosIdInput("");
                  setReferenceIdInput("");
                  setDate(null);
                  setStatus("");
                }}
              />
            </FilterSection>
          </FIlterHeader>
          <FilterContainer>
              <FilterInput
                value={sosIdInput}
                type="number"
                size="small"
                disabled={loading}
                variant="outlined"
                onChange={(event) => {
                  const val = event.target.value;
                  if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0)) {
                    setSosIdInput(val);
                  }
                }}
                label="Id"
                InputProps={{ inputProps: { min: 0 } }}
              />

              <FilterInput
                value={referenceIdInput}
                type="number"
                size="small"
                disabled={loading}
                variant="outlined"
                onChange={(event) => {
                  const val = event.target.value;
                  if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0)) {
                    setReferenceIdInput(val); 
                  }
                }}
                label="Reference Id"
                InputProps={{ inputProps: { min: 0 } }}
              />

              <DatePicker
                label="Date"
                disableMaskedInput
                value={date}
                inputFormat="dd/MM/yyyy"
                disabled={loading}
                onChange={(value) => {
                  setDate(value);
                  setPage(0);
                }}
                renderInput={(params) => (
                  <FilterTextField {...params} size="small" variant="outlined" />
                )}
              />


              <FilterTextField
                select
                label="Status"
                size="small"
                variant="outlined"
                value={status}
                disabled={loading}
                onChange={(e) => {
                  setStatus(e.target.value as CkSosTicketStatusEnum);
                  setPage(0);
                }}
                sx={{ minWidth: 180 }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value={CkSosTicketStatusEnum.OPEN}>Open</MenuItem>
                <MenuItem value={CkSosTicketStatusEnum.IN_PROGRESS}>In Progress</MenuItem>
                <MenuItem value={CkSosTicketStatusEnum.RESOLVED}>Resolved</MenuItem>
                <MenuItem value={CkSosTicketStatusEnum.CLOSED}>Closed</MenuItem>
              </FilterTextField>

          </FilterContainer>
        </FilterWrapper>
        <br />
        <SosAlertList
          data={data}
          loading={loading}
          page={page}
          rowsPerPage={rowsPerPage}
          total={total}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          onRefresh={loadData}
        />

        </WorkspaceContainer>
    )
}

export default SosAlerts;